import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UfFlowTopicDto} from '../../../model/dto/entity/uf-flow-topic.dto';
import {UfTopicStatusEnum} from '../../../model/dto/enum/uf-topic-status.enum';
import {MvsCrudService} from '../../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../../core/shared/service/crud/mvs-crud-mode.enum';
import {ObjectRequestList} from '../../../../../core/shared/dto/object/request/object-request-list';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {Sorting} from '../../../../../core/shared/misc/sorting';
import {DtoList} from '../../../../../core/shared/dto/dto.list';

@Injectable({
    providedIn: 'root'
})
export class UfFlowTopicService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/uf/flowTopics');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

    public listTopicsForFlow(flowId: number): Observable<DtoList> {
        return this.list(new ObjectRequestList(
            true,
            [FilterCriteria.create('flow.id', FilterCriteria.cOperatorEqual, flowId)],
            [new Sorting('createdDate', false)]
        ));
    }

    public listOpenTopicsForFlow(flowId: number): Observable<DtoList> {
        return this.list(new ObjectRequestList(
            true,
            [
                FilterCriteria.create('flow.id', FilterCriteria.cOperatorEqual, flowId),
                FilterCriteria.create('status', FilterCriteria.cOperatorNotEqual, 'resolved')
            ],
            [new Sorting('severity', false), new Sorting('createdDate', false)]
        ));
    }

    public resolveTopic(topicId: number, resolutionNote?: string): Observable<UfFlowTopicDto> {
        const updateDto = new UfFlowTopicDto();
        updateDto.id = topicId;
        updateDto.status = UfTopicStatusEnum.resolved;
        updateDto.resolutionNote = resolutionNote;
        updateDto.resolvedAt = new Date();
        return <Observable<UfFlowTopicDto>>this.update(updateDto);
    }

    public escalateTopic(topicId: number): Observable<UfFlowTopicDto> {
        return <Observable<UfFlowTopicDto>>this.postBasic({topicId}, '/escalate');
    }
}
